export const MAX_IMAGE_SIZE_BYTES = 2 * 1024 * 1024;
export const MAX_IMAGE_SIZE_LABEL = '2 МБ';

export function validateImageFile(file) {
  if (!file) {
    return { ok: false, message: 'Файл не выбран' };
  }
  if (!file.type.startsWith('image/')) {
    return { ok: false, message: 'Можно загружать только изображения (JPG, PNG, WebP и т.д.)' };
  }
  if (file.size > MAX_IMAGE_SIZE_BYTES) {
    const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
    return {
      ok: false,
      message: `Файл слишком большой (${sizeMb} МБ). Максимальный размер — ${MAX_IMAGE_SIZE_LABEL}.`,
    };
  }
  return { ok: true };
}
